import store from 'store';
import TagManager from 'react-gtm-module';

import { config } from './config';

const appMedium = store.get(config.user.isPWA) ? 'progressiveWebApp' : 'browserWebApp';

const getAdditionalDataLayer = () => {
    const isLoggedIn = store.get(config.user.token);
    const user = store.get(config.user.data);

    return {
        environment: window.location.hostname === 'www.iqos.ro' ? 'production' : 'staging',
        environmentVersion: process.env.REACT_APP_VERSION || '',
        page: {
            pageInfo: {
                pageID: window.location.pathname,
                pageName: 'IQOS Club',
                pageBrand: 'p1'
            },
            category: {
                primaryCategory: 'IQOS Club',
                pageType: ''
            },
            attributes: {
                country: 'RO',
                language: 'ro-RO',
                currency: 'RON'
            },
            user: {
                affiliation: isLoggedIn ? 'Registered' : 'Anonymous',
                ...(user?.acs_id && { dcsID: user.acs_id }),
                ...(user?.dcs_id && { ecomID: user.dcs_id })
            }
        }
    };
};

const getDataLayer = (eventCategory, eventAction, eventLabel) => ({
    dataLayer: {
        event: 'gtmZoneEvent',
        appMedium,
        eventCategory,
        eventAction,
        eventLabel
    }
});

const getLegalAgeDataLayer = (selectedLegalAgeBoolean) => ({
    dataLayer: {
        event: 'gatewayLegalAge',
        selectedLegalAgeBoolean
    }
});

const getLegalAgeDisplay = () => ({
    dataLayer: {
        event: 'gatewayLegalAgeDisplay'
    }
});

const TagEvents = {
    init: { gtmId: config.storage.gtmId },

    pageView: { dataLayer: { appMedium, ...getAdditionalDataLayer() } },
    gatewayLegalAge: (selectedLegalAgeBoolean) => getLegalAgeDataLayer(selectedLegalAgeBoolean),
    getLegalAgeDisplay: () => getLegalAgeDisplay(),

    loginSuccess: getDataLayer('account_login', 'login_success', 'login_success'),
    loginError: getDataLayer('account_login', 'login_error', 'login_error'),

};

export { TagManager, TagEvents };
